import { z } from 'zod';
export const MonetaryValueSchema = z.object({
    /** ISO 4217 currency code, e.g. 'EUR' */
    currency: z.string(),
    /** amount in the smallest currency unit (e.g. cents) */
    amount: z.number(),
});
export const MoneyPerAreaValueSchema = MonetaryValueSchema.extend({
    area_unit: z.string(),
});
export const SquareMetreMoneyPerAreaValueSchema = MoneyPerAreaValueSchema.extend({
    area_unit: z.literal('m²'),
});
export const MoneyPerUnitSchema = MonetaryValueSchema.extend({
    area_unit: z.string(),
});
